import React, { Component } from 'react';
import './highlightedFeedback.css';
import {Auth} from 'aws-amplify';
import DevControlPanel from './devControlPanel/devControlPanel';
import FeedbackStatus from './feedbackStatus/feedbackStatus.js';

class HighlightedFeedback extends Component {

  state = {
    devAccount: false
  }

  componentDidMount() {

    Auth.currentAuthenticatedUser()
    .then(user => {
      if (user.username === 'daniel.thomas') this.setState({devAccount: true});
    })
    .catch(err => {
      console.log(err);
    });

  }

  render() {

    return (
      <React.Fragment>
        {this.state.devAccount && <DevControlPanel id={this.props.feedback.id} handleDownloadingFeedback={this.props.handleDownloadingFeedback}/>}
        <div className={`HighlightedFeedbackPage${this.state.devAccount ? ' HighlightedFeedbackPageDev' : ''} Status${this.props.feedback.status[0].status.replace(' ','')}`}>
          <div className="TopLine">
            <h2><b>{this.props.feedback.app}</b> - <b>{this.props.feedback.type}</b> - <span className={`${this.props.feedback.priority}PriorityText`}><b>{this.props.feedback.priority} Priority</b></span></h2>
          </div>
          <div className="SecondLine">
            <h4>Submitted by <b>{this.props.feedback.user}</b> - {this.formattedDate(this.props.feedback.date)}</h4>
          </div>
          <div className="Body">
            <span>{this.props.feedback.body}</span>
          </div>
          <div className="Updates">
                      Status: <span>{this.props.feedback.status[0].status}</span>
          </div>
          <div className="StatusContainer">
            {this.props.feedback.status.map(status => {
              return <FeedbackStatus key={status.date} status={status}/>;
            })}
          </div>
        </div>
      </React.Fragment>
    );
  }

    formattedDate = date => {

      const jsDate = new Date(date);

      const hour = jsDate.getHours().toString().padStart(2,'0');
      const minute = jsDate.getMinutes().toString().padStart(2,'0');
      const second = jsDate.getSeconds().toString().padStart(2,'0');
      const time = `${hour}:${minute}:${second}`;

      const day = jsDate.getDate().toString().padStart(2,'0');
      const month = (jsDate.getMonth() + 1).toString().padStart(2,'0');
      const year = jsDate.getFullYear().toString().padStart(2,'0');
      const formattedDate = `${day}/${month}/${year}`;

      return `${time} ${formattedDate}`;
    }

}

export default HighlightedFeedback;


// WEBPACK FOOTER //
// ./src/components/content/feedback/highlightedFeedback/highlightedFeedback.js